import { Component, OnInit } from "@angular/core";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DashboardMainService } from "../../dashboard-main.service";
import * as moment from "moment";

@Component({
	selector: "app-dashboard-main",
	templateUrl: "./dashboard-main.component.html",
	styleUrls: ["./dashboard-main.component.css"],
})
export class DashboardMainComponent implements OnInit {
	constructor(private selectService: SchoolselectorService, private dashboardService: DashboardMainService) {}

	ngOnInit(): void {
		this.loadDashboardAds();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	////////////////////////////////////////////////////////////////////////////
	//#region Data
	////////////////////////////////////////////////////////////////////////////

	subscription: any;
	School: any;

	pagefirst: number = 0;

	//#region Student Attendance
	AttendanceLoading: boolean = false;

	SA_SchoolNumber: string = "N/A";
	SA_Tardy: string = "N/A";
	SA_Absent: string = "N/A";
	SA_OnTime: string = "N/A";
	SA_BarcodeEntries: string = "N/A";
	SA_ManualEntries: string = "N/A";
	SA_ClassAttendanceEntries: string = "N/A";
	SA_TotalSuspensions: string = "N/A";
	SA_OtherEntries: string = "N/A";
	SA_OutOfSchoolSuspensions: string = "N/A";
	SA_InSchoolSuspensions: string = "N/A";
	SA_EarlyRelease: string = "N/A";
	SA_PercentPresent: string = "N/A";
	SA_PercentAbsent: string = "N/A";
	//#endregion

	//#region Todays Events
	EventLoading: boolean = false;

	SelectedEvent: any;
	lstEvents: any = [];

	StudentAttendancePageRows: number = 5;

	EventCols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "EventDescShort", header: "Name" },
		{ field: "EventDescLong", header: "Description" },
		{ field: "EventLocation", header: "Location" },
	];

	EventTimeCols: any = [
		{ field: "DoorsOpenTimeDesc", header: "Doors Open Time" },
		{ field: "StartTimeDesc", header: "Start Time" },
		{ field: "EndTimeDesc", header: "End Time" },
	];

	//#endregion

	//#region Today's Releases

	ReleaseLoading: boolean = false;

	SelectedRelease: any;
	lstReleases: any = [];

	ReleasesPageRows: number = 5;

	lstReleaseTypeDesc: any = [];

	ReleaseCols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentName", header: "Name" },
		{ field: "ReleaseTypeDesc", header: "Release Type" },
		// { field: 'ReleaseTimeDesc', header: 'Time' },
		// { field: 'Comment', header: 'Comments' },
	];

	//#endregion

	//#region Today's Suspensions

	SuspensionLoading: boolean = false;

	SelectedSuspension: any;
	lstSuspensions: any = [];

	SuspensionPageRows: number = 5;

	lstIsPermanentDesc: any = [];
	lstInfractionDesc: any = [];
	lstSuspensionTypeDesc: any = [];

	SuspensionCols = [
		{ field: "StudentName", header: "Student Name" },
		{ field: "StudentID", header: "Student ID" },
		{ field: "SuspensionTypeDesc", header: "Student Type" },
		{ field: "SuspensionLength", header: "Suspension Length" },
		{ field: "InfractionDesc", header: "Infraction" },
	];

	SuspensionTypeID: any = 0;
	lstSuspensionType = [
		{
			ID: 0,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Out of School",
		},
		{
			ID: 2,
			Desc: "In-House",
		},
	];

	//#endregion

	DashboardAdLoading: boolean = false;
	lstDashboardAd: any = [];

	//#endregion
	////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////
	//#region Load Data
	////////////////////////////////////////////////////////////////////////////

	onRefresh() {
		//
		// Clear All Data
		//
		this.ClearData();

		if (this.School != undefined && this.School.SchoolID != undefined && this.School.SchoolID > 0) {
			this.loadStudentAttendance();
			this.loadTodaysEvents();
			this.loadReleaseList();
			this.loadSuspensionData();
		}
	}

	ClearData() {
		this.ClearStudentAttendance();
		this.lstEvents = [];
		this.lstReleases = [];
		this.lstSuspensions = [];

		this.lstReleaseTypeDesc = [];

		this.lstSuspensionTypeDesc = [];
		this.lstIsPermanentDesc = [];
		this.lstInfractionDesc = [];
	}

	loadStudentAttendance() {
		this.AttendanceLoading = true;

		var result = this.dashboardService.StudentDashboardAttendanceGetList(this.School.SchoolID);
		result.subscribe(
			(response: any) => {
				this.SA_PercentAbsent = response.AttendanceAbsentPercent + "%";
				this.SA_PercentPresent = response.AttendancePresentPercent + "%";
				this.SA_BarcodeEntries = response.EntryCountsBarcode;
				this.SA_ClassAttendanceEntries = response.EntryCountsClassAttendance;
				this.SA_ManualEntries = response.EntryCountsManual;
				this.SA_OtherEntries = response.EntryCountsOther;
				this.SA_EarlyRelease = response.ReleasesEarlyRelease;
				this.SA_Absent = response.SchoolAttendanceAbsent;
				this.SA_OnTime = response.SchoolAttendanceOnTime;
				this.SA_Tardy = response.SchoolAttendanceTardy;
				this.SA_SchoolNumber = response.SchoolNumber;
				this.SA_InSchoolSuspensions = response.SuspensionsInHouse;
				this.SA_OutOfSchoolSuspensions = response.SuspensionsOutOfSchool;
				this.SA_TotalSuspensions = response.SuspensionsTotal;

				this.AttendanceLoading = false;
			},
			(error) => {
				this.AttendanceLoading = false;
			}
		);
	}

	loadTodaysEvents() {
		this.EventLoading = true;

		var result = this.dashboardService.C9DashEventGetList(
			this.School.SchoolID,
			moment(new Date()).format("MM/DD/YYYY"),
			moment(new Date()).format("MM/DD/YYYY"),
			1
		);
		result.subscribe(
			(response) => {
				this.lstEvents = response;

				for (var z = 0; z < this.lstEvents.length; z++) {
					var next = this.lstEvents[z];

					next.DoorsOpenTimeDesc = moment(new Date(next.DoorsOpenTime)).format("h:mm a");
					next.StartTimeDesc = moment(new Date(next.StartTime)).format("h:mm a");
					next.EndTimeDesc = moment(new Date(next.EndTime)).format("h:mm a");
				}

				this.EventLoading = false;
			},
			(error) => {
				this.EventLoading = false;
			}
		);
	}

	loadReleaseList() {
		this.ReleaseLoading = true;

		var result = this.dashboardService.ReleaseGetList("", this.School.SchoolID, moment(new Date()).format("MM/DD/YYYY"));
		result.subscribe(
			(response) => {
				this.lstReleases = response;

				//Load Data Filter Lists
				this.lstReleaseTypeDesc = Array.from(new Set(this.lstReleases.map((item: any) => item.ReleaseTypeDesc))).sort();

				for (var z = 0; z < this.lstReleases.length; z++) {
					var next = this.lstReleases[z];

					next.PhotoData = this.ImageURL(next.PhotoData);
					next.ReleaseTimeDesc = this.FormatTime(next.ReleaseTime);
				}

				this.ReleaseLoading = false;
			},
			(error) => {
				this.ReleaseLoading = false;
			}
		);
	}

	loadSuspensionData() {
		this.SuspensionLoading = true;

		var result = this.dashboardService.StudentsOnSuspensionGetList(this.School.SchoolID, this.SuspensionTypeID);
		result.subscribe(
			(response) => {
				this.lstSuspensions = response;

				for (var z = 0; z < this.lstSuspensions.length; z++) {
					var next = this.lstSuspensions[z];

					next.PersonPhotoUrl = this.ImageURL(next.PersonPhotoUrl);
				}

				this.lstSuspensionTypeDesc = Array.from(new Set(this.lstSuspensions.map((item: any) => item.SuspensionTypeDesc))).sort();
				this.lstIsPermanentDesc = Array.from(new Set(this.lstSuspensions.map((item: any) => item.IsPermanentDesc))).sort();
				this.lstInfractionDesc = Array.from(new Set(this.lstSuspensions.map((item: any) => item.InfractionDesc))).sort();

				this.SuspensionLoading = false;
			},
			(error) => {
				this.SuspensionLoading = false;
			}
		);
	}

	loadDashboardAds() {
		this.DashboardAdLoading = true;

		var result = this.dashboardService.DashboardAdSimpleSelectList();
		result.subscribe(
			(response) => {
				this.lstDashboardAd = response;

				this.DashboardAdLoading = false;
			},
			(error) => {
				this.DashboardAdLoading = false;
			}
		);
	}

	//#endregion
	////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////
	//#region Events
	////////////////////////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.School = val;

		this.onRefresh();
	}

	onSuspensionTypeChange(val) {
		this.SuspensionTypeID = val;

		this.lstSuspensions = [];
		this.lstSuspensionTypeDesc = [];
		this.lstIsPermanentDesc = [];
		this.lstInfractionDesc = [];

		this.loadSuspensionData();
	}

	//#endregion
	////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////
	//#region Helpers
	////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.AttendanceLoading == true || this.EventLoading == true || this.ReleaseLoading == true || this.SuspensionLoading == true;
	}

	//#region Student Attendance

	ClearStudentAttendance() {
		this.SA_SchoolNumber = "N/A";
		this.SA_Tardy = "N/A";
		this.SA_Absent = "N/A";
		this.SA_OnTime = "N/A";
		this.SA_BarcodeEntries = "N/A";
		this.SA_ManualEntries = "N/A";
		this.SA_ClassAttendanceEntries = "N/A";
		this.SA_TotalSuspensions = "N/A";
		this.SA_OtherEntries = "N/A";
		this.SA_OutOfSchoolSuspensions = "N/A";
		this.SA_InSchoolSuspensions = "N/A";
		this.SA_EarlyRelease = "N/A";
		this.SA_PercentPresent = "N/A";
		this.SA_PercentAbsent = "N/A";
	}

	//#endregion

	//#region Today's Release

	FormatTime(val) {
		return moment(new Date(val)).format("h:mm A");
	}

	ImageURL(val) {
		// var imageBlob = this.dataURIToJPEGBlob(val);
		// var url = window.URL.createObjectURL(imageBlob);
		// return url;

		if (val != undefined && val.length > 0) {
			return "data:image/jpeg;base64," + val;
		} else {
			return "";
		}
	}

	dataURIToJPEGBlob(val) {
		const byteString = window.atob(val);
		const arrayBuffer = new ArrayBuffer(byteString.length);
		const int8Array = new Uint8Array(arrayBuffer);
		for (let i = 0; i < byteString.length; i++) {
			int8Array[i] = byteString.charCodeAt(i);
		}
		const blob = new Blob([int8Array], { type: "image/bmp" });
		return blob;
	}

	//#endregion

	//#endregion
	////////////////////////////////////////////////////////////////////////////
}
